import Vue from 'vue'

export default {
  UPDATE_NOTICEBAR(state, payload) {
    Vue.set(state.noticeBar, 'settings', payload)
  },
  SET_SETTINGS_TIMESTAMP(state, payload) {
    Vue.set(state.noticeBar.settings, 'timestamp', payload)
  }
}
